import React from "react";

import { FormControl } from "react-bootstrap";

import FsLiteInput from "./FsLiteInput";

export default class FsLiteSelect extends FsLiteInput {
  renderInput() {
    const { attribute, name, placeholder, disabled, value } = this.props;
    const { options, emptyOption } = this.props;

    if (options === undefined) {
      return null;
    }

    const optionsHtml = Array.isArray(options)
      ? options.map((option, index) => {
          return (
            <option key={index} value={option}>
              {option}
            </option>
          );
        })
      : Object.entries(options).map((valueAndContent, index) => {
          return (
            <option key={index} value={valueAndContent[0]}>
              {valueAndContent[1]}
            </option>
          );
        });

    return (
      <FormControl
        componentClass="select"
        name={name || attribute}
        value={value}
        onChange={this.update.bind(this)}
        placeholder={placeholder}
        disabled={disabled}
      >
        {emptyOption && (
          <option key="empty-option" value="">
            {emptyOption}
          </option>
        )}
        {optionsHtml}
      </FormControl>
    );
  }
}
